import React from "react";
import SchoolSignupForm from "../components/SchoolSignupForm";
import AuthWelcomePanel from "../components/auth/AuthWelcomePanel";
import { AuthPageContainer } from "../components/auth/DashboardAuthStyles";

const SchoolSignup: React.FC = () => {
  return (
    <AuthPageContainer data-testid="signup-page">
      <AuthWelcomePanel />
      <SchoolSignupForm />
    </AuthPageContainer>
  );
};

export default SchoolSignup;
